import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * #SK0001 获取商品搜索关键字列表
 */
export function getserchKeyword(data) {
  return request("".concat(BASE_URL) + "/keywords/list", METHOD.GET, data);
}

/**获取关键词配置信息（包括关键字商品列表）（#SK0002）
 * @param {Object} id
 */
export function serchKeywordDetail(id) {
  return request("".concat(BASE_URL) + "/keywords/get/" + id, METHOD.GET);
}

/** # 新增/编辑关键字
 * @param {Object} id
 */
export function addserchKeyword(id, data) {
  return request("".concat(BASE_URL) + "/keywords/AddUpdate/" + id, METHOD.POST, data);
}

/** #SK0003 删除关键字
 * @param {Object} id
 */
export function deleteserchKeyword(id) {
  return request("".concat(BASE_URL) + "/keywords/delete/" + id, METHOD.DELETE);
}